<template>
  <div class="play-mod">
    <video
      v-if="playState"
      id="vdoPlay"
      class="player"
      controls="controls"
      autoplay="autoplay"
      width="100%"
      :poster="video.poster"
    >
      <source
        :src="video.src"
        type="video/mp4"
      />
    </video>
    <div class="poster" v-else>
      <img :src="video.poster" @click="player" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playState: false
    }
  },
  props: {
    video: Object
  },
  methods: {
    player() {
      this.playState = true
    }
  }
}
</script>

<style lang="scss" scoped>
.play-mod{
  border-radius: 5px;
  overflow: hidden;
}
.player {
  width: 100%;
}
.poster {
  width: 100%;
  position: relative;
}
.poster:after{
  display:block;
  content:'';
  position:absolute;
  left:50%;top:50%;
  width:50px;height:50px;
  margin:-25px 0 0 -25px;
  background: url('../assets/img/play.png') no-repeat center center;
  background-size: cover;
  border-radius:100%;
  border:#eee solid 2px;
  z-index:2;
  pointer-events: none;
}
.poster img {
  width: 100%;
  display:block;
}
</style>